var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "invoice-dashboard h-full" },
    [
      !!_vm.sid
        ? _c("DetailModal", {
            attrs: { isManager: _vm.isManager },
            on: {
              close: _vm.onClose,
              projectClick: _vm.onProjectClick,
              "refetch-timesheet": _vm.handleRefectTimesheet,
            },
          })
        : _vm._e(),
      _c("Header", { attrs: { title: "Timesheets" } }),
      _c(
        "div",
        { staticClass: "mb-6" },
        [
          _c("Search", {
            attrs: {
              debounceTime: 500,
              placeholder: "Search by Resource name",
            },
            on: { search: _vm.handleSearch },
          }),
        ],
        1
      ),
      _vm.isManager
        ? _c(
            "div",
            { staticClass: "mb-8 w-1/5" },
            [
              _c("DropdownFilter", {
                attrs: {
                  withoutLoading: "",
                  placeholder: "Select company",
                  searchable: false,
                  multiple: false,
                  disabled: _vm.active_companies?.length === 0,
                  value: _vm.active_company,
                  options: _vm.active_companies,
                  customMultiStyleParent: "customWidthInput",
                },
                on: { input: _vm.setCompany },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "table-holder shadow bg-white rounded-md md py-4 px-7 mt-8 font-outfit",
        },
        [
          _c("Tabs", {
            attrs: {
              isAdmin: _vm.currentUser.role === "ADMIN",
              tabs: _vm.tabs,
              timesheets: _vm.timesheets,
              selectedRows: _vm.selectedRows,
              activeTab: _vm.activeTabIndex,
              tabClasses: "timesheets_tabs",
            },
            on: {
              "update:activeTab": function ($event) {
                _vm.activeTabIndex = $event
              },
              "update:active-tab": function ($event) {
                _vm.activeTabIndex = $event
              },
              "approve-selected": _vm.handleApproved,
              "reject-selected": _vm.handleOpenRejectModal,
              "download-selected": _vm.handleDownloadSelected,
              "download-all": _vm.downloadAllTimesheetsCSV,
            },
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.tabs, function (tab, index) {
                  return {
                    key: `tab-${index}`,
                    fn: function () {
                      return [
                        _c("TableView", {
                          key: index,
                          staticClass: "b-timehseet_list_table",
                          attrs: {
                            columns: _vm.columns,
                            getBodyRowClasses: _vm.getBodyRowClasses,
                            data: _vm.timesheets,
                            hasActions: true,
                            selectedRows: _vm.selectedRows,
                            selectedRowRecords: _vm.selectedItems,
                            loading: _vm.loading,
                            sort_by: _vm.sortBy,
                            sort_direction: _vm.sortDirection,
                          },
                          on: {
                            "update:selectedRows": function ($event) {
                              _vm.selectedRows = $event
                            },
                            "update:selected-rows": function ($event) {
                              _vm.selectedRows = $event
                            },
                            "update:selectedRowRecords": function ($event) {
                              _vm.selectedItems = $event
                            },
                            "update:selected-row-records": function ($event) {
                              _vm.selectedItems = $event
                            },
                            sort: _vm.handleSort,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "status",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "status",
                                        class: row.status,
                                      },
                                      [_vm._v(_vm._s(_vm.status(row.status)))]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "hours",
                                fn: function ({ row }) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertSecondsToHoursMinutesSeconds(
                                            row.tracked_time
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "user",
                                fn: function ({ row }) {
                                  return [
                                    _c("div", { staticClass: "user" }, [
                                      row.user?.avatar
                                        ? _c(
                                            "div",
                                            { staticClass: "user-image" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: row.user.avatar,
                                                  alt: row.user?.given_name,
                                                },
                                              }),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "user-initials",
                                              style: _vm.bgStyle(row),
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.initial(row)) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(row.user?.given_name) +
                                            " " +
                                            _vm._s(row.user?.family_name)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "period",
                                fn: function ({ row }) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.gettimeRangeFormat(
                                              row.start_date,
                                              row.end_date
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "actions",
                                fn: function ({ row }) {
                                  return [
                                    _c("MoreActions", {
                                      staticClass: "relative",
                                      attrs: {
                                        TooltipBoxStyle: "tooltipTimeSheet",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "action-buttons",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex flex-col bg-white",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "actionLink",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openSheetDetail(
                                                              row.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" View hours ")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    },
                    proxy: true,
                  }
                }),
              ],
              null,
              true
            ),
            model: {
              value: _vm.activeTabIndex,
              callback: function ($$v) {
                _vm.activeTabIndex = $$v
              },
              expression: "activeTabIndex",
            },
          }),
          _c("Pagination", {
            attrs: {
              limit: _vm.limit,
              current: _vm.currentPage,
              total: _vm.totalPages,
              paginationClasses: "timesheet_table_pagination",
            },
            on: {
              "limit-change": _vm.onLimitChange,
              "next-page": function ($event) {
                return _vm.changePage(1)
              },
              "prev-page": function ($event) {
                return _vm.changePage(-1)
              },
            },
          }),
        ],
        1
      ),
      _vm.showRejectModal
        ? _c("RejectionModal", {
            attrs: { showAlert: true },
            on: { submit: _vm.handleReject, close: _vm.handleCloseRejectModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }